var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01Lg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 8.16669L11.8592 14.8347C12.6306 15.3747 13.0163 15.6446 13.4358 15.7492C13.8064 15.8416 14.194 15.8416 14.5645 15.7492C14.984 15.6446 15.3697 15.3747 16.1411 14.8347L25.6668 8.16669M7.9335 23.3334H20.0668C22.027 23.3334 23.0071 23.3334 23.7558 22.9519C24.4144 22.6163 24.9498 22.0809 25.2854 21.4223C25.6668 20.6736 25.6668 19.6935 25.6668 17.7334V10.2667C25.6668 8.3065 25.6668 7.32641 25.2854 6.57772C24.9498 5.91915 24.4144 5.38372 23.7558 5.04816C23.0071 4.66669 22.027 4.66669 20.0668 4.66669H7.9335C5.97331 4.66669 4.99322 4.66669 4.24453 5.04816C3.58596 5.38372 3.05053 5.91915 2.71497 6.57772C2.3335 7.32641 2.3335 8.3065 2.3335 10.2667V17.7334C2.3335 19.6935 2.3335 20.6736 2.71497 21.4223C3.05053 22.0809 3.58596 22.6163 4.24453 22.9519C4.99322 23.3334 5.97331 23.3334 7.9335 23.3334Z",
    stroke: "#155EEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01Lg);
export default __webpack_public_path__ + "static/media/mail-01-lg.31ed9d81d7b03e567d3921a21f8aa4bd.svg";
export { ForwardRef as ReactComponent };